<template>
    <div>
        <v-card :disabled="disabled" elevation="0">
            <v-row v-if="application">
                <v-col cols="4" class="py-0">
                    <application-view-row label="기업명" v-model="inputs.companyName" />
                    <application-view-row label="대표자명" v-model="inputs.ceoName" />
                    <application-view-row label="사업자등록번호" v-model="inputs.businessNumber" />
                    <application-view-date label="설립일" v-model="inputs.establishedAt" />
                </v-col>
                <v-col cols="4" class="py-0">
                    <application-view-row label="주요생산제품" v-model="inputs.mainProduct" />
                    <application-view-worker v-model="inputs" />
                    <application-view-phone label="연락처" v-model="inputs.phone" />
                    <application-view-email label="이메일" v-model="inputs.email" />
                </v-col>
                <v-col cols="4" class="py-0">
                    <application-view-address v-model="inputs" />
                    <application-view-row label="홈페이지주소" v-model="inputs.website" />
                </v-col>
            </v-row>
        </v-card>
        <v-row v-if="application && application.files" align="center">
            <v-col cols="auto" class="py-0 text-subtitle-1"> 첨부파일 </v-col>
            <v-col class="py-0">
                <v-chip-group column>
                    <v-chip v-for="{ _id, url, fileName } in application.files" :key="_id" :href="url" outlined color="secondary" download>{{ fileName }}</v-chip>
                </v-chip-group>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from "@/api";
import VFileBtn from "@/components/plugins/vuetify/v-file-btn.vue";
import ApplicationViewRow from "./application-view-row.vue";
import ApplicationViewDate from "./application-view-date.vue";
import ApplicationViewEmail from "./application-view-email.vue";
import ApplicationViewPhone from "./application-view-phone.vue";
import ApplicationViewWorker from "./application-view-worker.vue";
import ApplicationViewAddress from "./application-view-address.vue";
import ApplicationViewAffiliations from "./application-view-affiliations.vue";

export default {
    components: {
        VFileBtn,
        ApplicationViewRow,
        ApplicationViewDate,
        ApplicationViewPhone,
        ApplicationViewEmail,
        ApplicationViewWorker,
        ApplicationViewAddress,
        ApplicationViewAffiliations,
    },
    props: ["_application", "disabled"],
    data() {
        return {
            application: null,
            inputs: {},
            files: [],
        };
    },
    methods: {
        async search() {
            try {
                const { application } = await api.console.services.applications.get({ _id: this._application });
                this.application = application;
                this.init();
            } catch (error) {
                this.$handleError(error);
            }
        },
        init() {
            this.inputs = { ...this.application.applicant };
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style></style>
